module.exports = __webpack_public_path__ + "img/land_characteristics_plain@2x.d9372652.png";